import { Inject, Injectable } from '@angular/core';
import { Params, Router } from '@angular/router';
import { TranslationService } from '../translation.service';
import { ENVIRONMENT_TOKEN } from '@lib/core';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  constructor(
    @Inject(ENVIRONMENT_TOKEN) protected environment: any,
    protected router: Router,
    protected translationService: TranslationService
  ) {}

  back(): void {
    window.history.back();
  }

  locationHref(href: string = '/'): void {
    window.location.href = href;
  }

  goToHomePage(signin?: boolean) {
    if (signin) {
      this.goTo(['screening'], { queryParams: { signin: 'true' } });
    } else {
      this.goTo(['screening']);
    }
  }

  goTo(url: any[], queryParameters?: Params) {
    const lang = this.environment.constants.language.useLangAsUrlParam ? this.translationService.currentLang + '/' : '';
    this.router.navigate([lang, ...url], queryParameters);
  }
}
